import { API, graphqlOperation } from "aws-amplify";
import { logError } from "../../../utils/appUtils"; // Adjust path as needed
import { barcodeByInventoryItemByActiveByValue } from "../../../graphql/queries";

export const handleScanButtonClick = async ({
  selectedInventoryItem,
  allBarcodes,
  pendingBarcodes,
  setAllBarcodes,
  setScanDialogOpen,
  notify,
}) => {
  if (!selectedInventoryItem?.id) {
    const existingIds = new Set(allBarcodes.map((b) => b.id));
    const merged = [
      ...allBarcodes,
      ...pendingBarcodes.filter((b) => !existingIds.has(b.id)),
    ];

    setAllBarcodes(merged);
    setScanDialogOpen(true);
    return;
  }

  try {
    const response = await API.graphql(
      graphqlOperation(barcodeByInventoryItemByActiveByValue, {
        inventoryItemId: selectedInventoryItem.id,
        active: "true",
      })
    );

    const itemBarcodes =
      response.data?.barcodeByInventoryItemByActiveByValue.items || [];

    const existingIds = new Set(allBarcodes.map((b) => b.id));
    const mergedBarcodes = [
      ...allBarcodes,
      ...itemBarcodes.filter((b) => !existingIds.has(b.id)),
    ];

    setAllBarcodes(mergedBarcodes);
    setScanDialogOpen(true);
  } catch (error) {
    logError("handleScanButtonClick", error, notify);
  }
};
